import React from "react";
import axios from "axios";
import FeedBackForm from "./UserFeedBack";
import ThankYouFeedBack from "./ThankYou";
import RegretScreen from "./RegretScreen";
import LoadingComponent from "./LoadingComponent";
import FeedBackAlreadyExists from "./FeedBackAlreadyExists";
import RatingScreen from "./RateResource";
import { serverUrl } from "../config";

class Platform {
  static OS = "web";
  static select = (config) => {
    if (config) {
      return config.web;
    }
  };
}

const detectMob = () => {
  if (
    Platform.OS !== "web" ||
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) {
    return true;
  } else {
    return false;
  }
};

const isMobile = detectMob();

class UserFeedbackView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ratings: 0,
      comment: void 0,
      starField: true,
      commentField: true,
      name: void 0,
      email: void 0,
      data: {},
      errorMessage: "",
      error: false,
      subsidiaryName: "",
      view: "feedBackForm",
      status: true,
      isFeedBackExists: void 0,
      projectName: void 0,
      message: void 0,
      referEmailError: void 0,
      customerName: void 0,
      clientName: void 0,
      serverResult: void 0,
      logo: void 0,
      isMobile,
      clientFeedbackID: void 0,
      userFeedbackReceived: false,
    };
  }
  componentDidMount = () => {
    const webUrl = window.location.href;
    const hash = webUrl && webUrl.split("#");
    const temp = hash[1] && hash[1].split("_");
    if (temp && Array.isArray(temp) && temp.length > 1) {
      const token = temp[0];
      const project = temp[1];
      const unique_mail_id = temp[2];
      const request_id = temp[3];
      const paramValue = {
        unique_mail_id,
        project,
        request_id,
      };
      this.fetch({
        uri: "/checkFeedbackExists",
        props: paramValue,
      })
        .then((result) => {
          // console.log("@@@@result===================", JSON.stringify(result));
          if (result && result.discount) {
            this.state.discount = result.discount;
          }
          if (result && result.isFeedBackExists !== undefined) {
            this.state.isFeedBackExists = result.isFeedBackExists;
          }
          if (result && result.clientName !== undefined) {
            this.state.clientName = result.clientName;
          }
          if (result && result.customerName !== undefined) {
            this.state.customerName = result.customerName;
          }
          if (result && result.projectName) {
            this.state.projectName = result.projectName;
          }
          if (result && result.subsidary && result.subsidary.logo) {
            const key = result.subsidary.logo.key;
            this.state.subsidiaryName = result.subsidary.name;
            this.state.logo = `https://devapi5.manaze.io/download?fileKey=${key}&token=7d3a9fe2ca0a8dd01d78809a1385fc9e9e293b56`;
          }
          if (result && result.clientFeedback) {
            this.state.clientFeedbackID = result.clientFeedback;
          }
          if (result && result.data) {
            this.state.data = result.data;
          }
          if (result) {
            this.setState({ serverResult: result });
          }
        })
        .catch((err) => {
          this.setState({ error: true, errorMessage: "error" });
        });
    }
  };

  handleError = (e) => {
    const errorResponse =
      e.response && e.response.data && e.response.data.response;
    if (errorResponse && errorResponse.error) {
      const { message = void 0, code = void 0 } = errorResponse.error;
      const modifiedError = new Error(message);
      modifiedError.code = code;
      throw modifiedError;
    } else {
      throw e;
    }
  };

  fetch = ({ uri, props }) => {
    return axios
      .post(`${serverUrl}${uri}`, props)
      .then((res) => {
        const { data } = res.data;
        return data;
      })
      .catch((e) => {
        this.handleError(e);
      });
  };

  updateState = (data) => {
    this.setState({
      ...data,
    });
  };

  saveResourceRating = (resourceFeedback) => {
    const parseUrlResult = this.parseUrl();
    const { token, ...rest } = parseUrlResult;
    const { clientFeedbackID } = this.state;
    for (const resource of resourceFeedback) {
      if (
        !resource.resourceRating ||
        !resource.resourceComment ||
        !resource.resourceName
      ) {
        this.setState({ starField: false });
        return null;
      }
    }
    const paramValue = {
      ...rest,
      resourceFeedback,
      clientFeedbackID,
    };
    this.fetch({
      uri: "/saveResourceFeedback",
      props: paramValue,
    }).then((result) => {
      this.setState({ userFeedbackReceived: true, view: "thankYouFeedBack" });
    });
  };

  parseUrl = () => {
    let hash = window.location.href;
    hash = hash && hash.split("#");
    const temp = hash[1] && hash[1].split("_");
    let project = null;
    let goal = null;
    let unique_mail_id = null;
    let request_id = null;
    let token = null;
    if (temp && Array.isArray(temp) && temp.length > 1) {
      token = temp[0];
      project = temp[1];
      unique_mail_id = temp[2];
      if (temp[3] && temp[3] === "goal") {
        goal = temp[1];
      } else {
        request_id = temp[3];
      }
    }
    const result = {
      project: project,
      goal: goal,
      unique_mail_id: unique_mail_id,
      request_id: request_id,
      token: token,
    };
    return result;
  };

  onSubmit = async (data) => {
    if (data && !data.ratings && !data.comment) {
      this.setState({
        starField: false,
        commentField: false,
        errorMessage: "Rating and comments are mandatory",
        error: true,
      });
      setTimeout(() => this.setState({ error: false }), 2000);
      return null;
    }
    if (data && !data.ratings) {
      this.setState({ starField: false });
      return null;
    }
    if (data && !data.comment) {
      this.setState({ commentField: false });
      return null;
    }
    const parseUrlResult = this.parseUrl();

    const { goal, request_id, project, token, unique_mail_id } = parseUrlResult;

    if (data && data.view) {
      this.setState({
        view: data.view,
      });
    }
    const resourceFeedback = Object.keys(data).reduce((acc, one) => {
      if (one.indexOf("_id_") !== -1) {
        acc.push({
          client_score: data[one],
          resource: { _id: one.replace("_id_", "") },
        });
      }
      return acc;
    }, []);
    const paramValue = {
      ...data,
      resourceFeedback,
      comment: data.comment,
      ratings: data.ratings,
      project,
      goal,
      unique_mail_id,
      request_id,
      friendEmail: data.email,
      friendName: data.name,
      companyName: data.companyName,
      message: data.message,
    };
    this.fetch({
      uri: "/saveClientFeedback",
      props: paramValue,
    }).then((result) => {
      // console.log("result", result);
      // this.setState({clientFeedbackID : result.data._id});
    });
  };

  render() {
    const {
      serverResult,
      isFeedBackExists,
      starField,
      isMobile,
      logo,
      projectName,
      data,
      userFeedbackReceived,
      subsidiaryName,
    } = this.state;
    let component;
    if (!serverResult) {
      component = <LoadingComponent />;
    } else {
      if (!isFeedBackExists) {
        switch (this.state.view) {
          case "feedBackForm": {
            component = (
              <FeedBackForm
                onSubmit={this.onSubmit}
                data={this.state.data}
                starField={this.state.starField}
                commentField={this.state.commentField}
                subsidiaryName={subsidiaryName}
                isMobile={isMobile}
                logo={logo}
              />
            );
            break;
          }
          case "thankYouFeedBack": {
            component = (
              <ThankYouFeedBack
                isMobile={isMobile}
                logo={logo}
                data={{
                  ...data,
                  subsidiaryName,
                  updateState: this.updateState,
                  userFeedbackReceived,
                }}
              />
            );
            break;
          }
          case "regretScreen": {
            component = <RegretScreen isMobile={isMobile} logo={logo} />;
            break;
          }
          case "resourceRatingScreen": {
            component = (
              <RatingScreen
                isMobile={isMobile}
                logo={logo}
                data={{
                  ...data,
                  subsidiaryName,
                  starField,
                  saveResourceRating: this.saveResourceRating,
                }}
              />
            );
            break;
          }
          default: {
            component = null;
          }
        }
      } else {
        component = (
          <FeedBackAlreadyExists
            isMobile={isMobile}
            logo={logo}
            subsidiaryName={subsidiaryName}
          />
        );
      }
    }
    return (
      <div style={{ flex: 1 }}>
        {React.cloneElement(component)}
        {this.state.error ? (
          <div style={{ position: "fixed", bottom: 100, left: 0, right: 0 }}>
            <div
              style={{
                display: "flex",
                flex: 1,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: 4,
                  boxShadow: "2px 2px 2px 2px #000000",
                  padding: 5,
                }}
              >
                {this.state.errorMessage}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default UserFeedbackView;
